/**
 * RecepcionConfigModal.jsx — Texto legal que se imprime en la boleta de Recepción de Equipos (por empresa).
 */
import React, { useState, useEffect } from "react";
import { X, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function RecepcionConfigModal({ API, token, logoTipo, canEdit, onClose }) {
  const [texto, setTexto] = useState("");
  const [defecto, setDefecto] = useState("");
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

  useEffect(() => {
    fetch(`${API}/admin/presupuestos/recepcion-config/texto?logo_tipo=${encodeURIComponent(logoTipo)}`, { headers })
      .then(r => (r.ok ? r.json() : Promise.reject()))
      .then(d => { setTexto(d.texto_legal || ""); setDefecto(d.default || ""); })
      .catch(() => toast.error("No se pudo cargar la configuración"))
      .finally(() => setCargando(false));
    // eslint-disable-next-line
  }, []);

  const guardar = async () => {
    setGuardando(true);
    try {
      const r = await fetch(`${API}/admin/presupuestos/recepcion-config/texto`, { method: "PUT", headers, body: JSON.stringify({ logo_tipo: logoTipo, texto_legal: texto }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "No se pudo guardar");
      toast.success("Texto de la boleta guardado");
      onClose();
    } catch (e) { toast.error(e.message); }
    setGuardando(false);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="relative bg-arandu-dark-light border border-white/10 rounded-2xl w-full max-w-2xl p-6 shadow-2xl">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h2 className="font-heading text-lg text-white">Texto de la boleta de recepción</h2>
            <p className="text-slate-400 text-sm">Se imprime en el recuadro de condiciones de la boleta de Recepción de Equipos. Cada línea se imprime en un renglón nuevo.</p>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        {cargando ? <div className="py-8 text-center"><Loader2 className="w-5 h-5 animate-spin inline text-slate-300" /></div> : (
          <>
            <textarea rows={7} value={texto} onChange={e => setTexto(e.target.value)} disabled={!canEdit}
              placeholder="Dejá vacío para no imprimir ningún texto"
              className="w-full bg-arandu-dark border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-cyan-400" />
            <div className="flex justify-between items-center mt-3">
              {canEdit ? <button className="text-xs text-orange-300 underline" onClick={() => setTexto(defecto)}>Restaurar texto original</button> : <span />}
              <div className="flex gap-2">
                <button onClick={onClose} className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-sm text-slate-300">Cerrar</button>
                {canEdit && (
                  <button onClick={guardar} disabled={guardando} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-700 disabled:opacity-50 text-sm text-white">
                    <Save className="w-4 h-4" /> {guardando ? "Guardando..." : "Guardar"}
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
